const $ = require('jquery');

class GooglePlacesAutocompleteController {
    constructor($scope, $element, $timeout) {
        this.$scope = $scope;
        this.$timeout = $timeout;

        this.autocomplete = new window.google.maps.places.Autocomplete($element[0], {
            componentRestrictions: { country: 'au' },
        });

        this.autocomplete.addListener('place_changed', () => this.$scope.$apply(
            () => this.placeChanged(),
        ));

        // This prevents form submission when selecting a place from the dropdown
        // using the enter key. We need to do this because the form submission
        // happens before google updates the selected place, meaning the form
        // is submitted without having selected the new place.
        // see: https://stackoverflow.com/questions/27072844/google-places-autocomplete-place-changed-event-fires-after-form-submission-when
        $element.on('keydown', (e) => {
            if (e.which === 13 && $('.pac-container:visible').length) {
                e.preventDefault();
            }
        });
    }

    placeChanged() {
        this.place = this.autocomplete.getPlace();

        this.$timeout(() => this.onPlaceChanged());
    }
}

const googlePlacesAutocompleteDirectiveDefinition = () => ({
    restrict: 'A',
    scope: {},
    bindToController: {
        autocomplete: '=?',
        place: '=',
        onPlaceChanged: '&',
    },
    controller: ['$scope', '$element', '$timeout', GooglePlacesAutocompleteController],
    controllerAs: 'googlePlacesAutocompleteCtrl',
});

module.exports = {
    GooglePlacesAutocompleteController,
    googlePlacesAutocompleteDirectiveDefinition,
};



// WEBPACK FOOTER //
// ./src/olycommon/googlemaps/google-places-autocomplete.directive.js